import { render, staticRenderFns } from "./RouteItemDatePicker.vue?vue&type=template&id=87e84cd0"
import script from "./RouteItemDatePicker.vue?vue&type=script&lang=js"
export * from "./RouteItemDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports